<div class="inner-content">
  <div class="flex items-center justify-between">
    <div class="flex flex-row items-center gap-2">
      <ion-icon class="title-icon" [icon]="titleIcon"></ion-icon>
      <span class="title barlow">{{ title }}</span>
    </div>
    <ion-icon
      class="close-icon cursor-pointer"
      icon="assets/icon/cross.svg"
      (click)="modalController.dismiss()"
    ></ion-icon>
  </div>
  <hr />
  <div class="textarea-container w-100">
    <ion-label *ngIf="label" class="label barlow">{{ label }}</ion-label>
    <ion-textarea
      class="barlow"
      fill="outline"
      [autoGrow]="false"
      [counter]="true"
      [maxlength]="maxLength"
      [rows]="rows"
      mode="md"
      [placeholder]="placeholder"
      [(ngModel)]="currentText"
    >
    </ion-textarea>
  </div>
  <hr />
  <div class="w-100 flex flex-row justify-end gap-2.5">
    <ion-button color="medium-light" (click)="cancel()">Cancelar</ion-button>
    <ion-button [disabled]="!currentText.length && !allowEmpty" (click)="submit()">Guardar y continuar </ion-button>
  </div>
</div>
